import { FC } from 'react';

import { cn } from '@distribute/frontend/utils';
import { Avatar, Tooltip } from '../../../../shared/ui';

type Props = {
  url?: string;
  displayName: string;
  className?: string;
  users: {
    email: string;
    name: string;
  }[];
};

export const TableUser: FC<Props> = ({
  url,
  displayName,
  users,
  className,
}) => {
  return (
    <Tooltip
      className="px-3 py-2"
      hideArrow
      trigger={
        <Avatar
          className={cn('border border-base-black/[0.08]', className)}
          isUserAvatar
          src={url}
          displayName={displayName}
          size="xs"
        />
      }
    >
      {users.map((user) => (
        <p key={user.email}>
          <span className="font-semibold">{user.name} </span>
          {`(${user.email})`}
        </p>
      ))}
    </Tooltip>
  );
};
